import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { EnableAutoReloadInput } from '@/models/caller';

export const enableAutoReload = async ({
  autoReloadCreditsPaymentAmount,
  autoReloadCreditsThresholdAmount,
  callerId,
}: EnableAutoReloadInput): Promise<boolean> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation EnableAutoReload($autoReloadCreditsPaymentAmount: Float!, $autoReloadCreditsThresholdAmount: Float!, $callerId: String!) {
        enableAutoReload(
          autoReloadCreditsPaymentAmount: $autoReloadCreditsPaymentAmount
          autoReloadCreditsThresholdAmount: $autoReloadCreditsThresholdAmount
          callerId: $callerId
        ) {
          id
        }
      }
    `),
    variables: {
      autoReloadCreditsPaymentAmount,
      autoReloadCreditsThresholdAmount,
      callerId,
    },
  });

  return !!response.data?.enableAutoReload;
};
